import React, { useState } from 'react';
import styles from '../ProductForms.module.css';

const AddProductForm = () => {
    const [formData, setFormData] = useState({
        categoria: '',
        equipo: '',
        marca: '',
        modelo: '',
        cantidad: '',
        estado: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleImageChange = (e) => {
        setFormData({
            ...formData,
            imagen: e.target.files[0]
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Aquí puedes manejar el envío del formulario, por ejemplo, enviándolo a una API
    };

    return (
        <form className={styles.addProductForm} onSubmit={handleSubmit}>
            <h2>Agregar nuevo producto</h2>
            <div className={styles.formContainer}>
                <div className={styles.formFields}>
                    <div className={styles.formularioGrupo}>
                        <input
                            type="text"
                            name="categoria"
                            value={formData.categoria}
                            onChange={handleChange}
                            placeholder="Categoría"
                            className={styles.inputFullWidth}
                        />
                    </div>
                    <div className={styles.formularioGrupo}>
                        <input
                            type="text"
                            name="equipo"
                            value={formData.equipo}
                            onChange={handleChange}
                            placeholder="Equipo"
                            className={styles.inputFullWidth}
                        />
                    </div>
                    <div className={styles.formularioGrupo}>
                        <input
                            type="text"
                            name="marca"
                            value={formData.marca}
                            onChange={handleChange}
                            placeholder="Marca"
                            className={styles.inputFullWidth}
                        />
                    </div>
                    <div className={styles.formularioGrupo}>
                        <input
                            type="text"
                            name="modelo"
                            value={formData.modelo}
                            onChange={handleChange}
                            placeholder="Modelo/ Color/ Ubicación/ Año"
                            className={styles.inputFullWidth}
                        />
                    </div>
                    <div className={styles.formularioGrupo}>
                        <input
                            type="number"
                            name="cantidad"
                            value={formData.cantidad}
                            onChange={handleChange}
                            placeholder="Cantidad"
                            className={styles.inputFullWidth}
                        />
                    </div>
                    <div className={styles.formularioGrupo}>
                        <input
                            type="text"
                            name="estado"
                            value={formData.estado}
                            onChange={handleChange}
                            placeholder="Estado activo o inactivo"
                            className={styles.inputFullWidth}
                        />
                    </div>
                </div>
                <div className={styles.formImage}>
                    <div className={styles.formularioGrupo}>
                        <label>Imagen</label>
                        <input type="file" accept="image/*" onChange={handleImageChange} className={styles.inputFullWidth} />
                        {formData.imagen && <img src={URL.createObjectURL(formData.imagen)} alt="Vista previa" className={styles.imagePreview} />}
                    </div>
                    <div className="button-container">
                        <button type="submit" className={styles.addSubmitButton}>Guardar datos</button>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default AddProductForm;
